import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/LOGO-TRUE-BLUE-FOOTER.svg")